import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 19 33",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M7.10938 20.1183V30.0644L8.50713 32.1604C8.80864 32.6124 9.47324 32.6124 9.77476 32.1604L11.1719 30.0644V20.1183C10.5124 20.2401 9.83506 20.3125 9.14062 20.3125C8.44619 20.3125 7.7689 20.2401 7.10938 20.1183ZM9.14062 0C4.09233 0 0 4.09233 0 9.14063C0 14.1889 4.09233 18.2813 9.14062 18.2813C14.1889 18.2813 18.2812 14.1889 18.2812 9.14063C18.2812 4.09233 14.1889 0 9.14062 0ZM9.14062 4.82422C6.76025 4.82422 4.82422 6.76025 4.82422 9.14063C4.82422 9.56084 4.48271 9.90234 4.0625 9.90234C3.64229 9.90234 3.30078 9.56084 3.30078 9.14063C3.30078 5.92046 5.92109 3.30078 9.14062 3.30078C9.56084 3.30078 9.90234 3.64229 9.90234 4.0625C9.90234 4.48272 9.56084 4.82422 9.14062 4.82422Z",
      fill: "currentColor"
    }, null, -1)
  ])))
}
export default { render: render }